var _rect, _rect2, _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionMap3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 122,
    viewBox: "0 0 182 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1.84122,
    y: 1.84122,
    width: 59.3176,
    height: 118.318,
    fill: "#B235DD",
    fillOpacity: 0.4,
    stroke: "#C635DD",
    strokeWidth: 3.68244
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_309_398",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 122
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 122,
    fill: "#6BDD35"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_309_398)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 18,
    r: 18,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 13,
    r: 18,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 10,
    r: 18,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 8,
    r: 29,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 10,
    r: 29,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 12,
    r: 29,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 19,
    r: 29,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 10,
    r: 29,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 13,
    r: 29,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 15,
    r: 29,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 27,
    r: 29,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 46.5,
    r: 26.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 40.5,
    r: 26.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 36.5,
    r: 26.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 36.5,
    r: 19.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 35.5,
    r: 19.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 41.5,
    r: 19.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 41.5,
    r: 19.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 41.5,
    r: 19.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 25.5,
    r: 11.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 20.5,
    r: 11.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 19.5,
    r: 11.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 85.5,
    r: 14.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 84.5,
    r: 14.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 82.5,
    r: 14.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -3.5,
    cy: 78.5,
    r: 14.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -3.5,
    cy: 78.5,
    r: 14.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 100.5,
    r: 14.5,
    fill: "#7C3495",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 18,
    r: 18,
    fill: "#7C3495",
    fillOpacity: 0.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.016 26.5312C154.359 26.5391 156.578 27.9375 156.578 32.0469C156.586 35.8906 154.766 38.1562 151.922 38.1562C149.648 38.1562 148.086 36.7266 147.859 34.8125H150.172C150.367 35.6484 151.016 36.1406 151.922 36.1406C153.461 36.1406 154.273 34.7578 154.281 32.5H154.188C153.656 33.5 152.539 34.0938 151.281 34.0938C149.25 34.0938 147.75 32.5625 147.734 30.4531C147.734 28.1797 149.461 26.5234 152.016 26.5312ZM150.031 30.3906C150.031 31.5078 150.852 32.375 152.016 32.375C153.164 32.375 154.047 31.4609 154.047 30.375C154.031 29.2969 153.188 28.3828 152.031 28.375C150.875 28.3828 150.016 29.2656 150.031 30.3906ZM158.297 38L163.062 28.6875V28.6094H157.516V26.6875H165.5V28.6406L160.734 38H158.297ZM170.031 32.3438C168.336 32.3438 167.422 31.1094 167.422 29.3281C167.422 27.5391 168.383 26.2969 170.031 26.2969C171.727 26.2969 172.633 27.5391 172.641 29.3281C172.633 31.125 171.703 32.3438 170.031 32.3438ZM169.016 29.3281C169.023 30.3047 169.375 30.9453 170.031 30.9531C170.703 30.9453 171.039 30.3047 171.047 29.3281C171.039 28.3516 170.734 27.6875 170.031 27.6875C169.367 27.6953 169.023 28.3672 169.016 29.3281ZM169.047 38L176.828 26.6875H178.578L170.797 38H169.047ZM175.062 35.3594C175.062 33.5703 176.023 32.3359 177.656 32.3281C179.367 32.3359 180.273 33.5703 180.281 35.3594C180.273 37.1562 179.344 38.375 177.656 38.375C175.977 38.375 175.062 37.1406 175.062 35.3594ZM176.656 35.3594C176.664 36.3359 177.016 36.9844 177.656 36.9844C178.344 36.9844 178.68 36.3359 178.688 35.3594C178.68 34.3828 178.367 33.7188 177.656 33.7344C177 33.7266 176.664 34.3984 176.656 35.3594Z",
    fill: "#CDD0DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3887 85.1367C93.3379 85.1367 91.8818 84.0361 91.8203 82.416H93.3516C93.4062 83.2842 94.2676 83.8379 95.375 83.8379C96.5713 83.8379 97.4395 83.1885 97.4395 82.2246C97.4395 81.2471 96.626 80.5498 95.2109 80.543H94.3633V79.3125H95.2109C96.3389 79.3193 97.125 78.6904 97.125 77.7402C97.125 76.8379 96.4482 76.2227 95.4023 76.2227C94.4111 76.2227 93.5225 76.7764 93.4883 77.6719H92.0391C92.0801 76.0586 93.5703 74.9648 95.416 74.9648C97.3643 74.9648 98.5879 76.1953 98.5742 77.6582C98.5879 78.7861 97.8906 79.5928 96.8242 79.8594V79.9277C98.1777 80.1191 98.9639 81.0283 98.957 82.2793C98.9639 83.9268 97.4395 85.1367 95.3887 85.1367ZM102.881 79.8047C101.527 79.8184 100.789 78.8135 100.803 77.3438C100.789 75.8945 101.562 74.8896 102.881 74.8965C104.241 74.8896 104.952 75.8945 104.959 77.3438C104.952 78.8203 104.214 79.8184 102.881 79.8047ZM101.924 85L108.719 75.1016H109.963L103.168 85H101.924ZM101.924 77.3438C101.931 78.2529 102.245 78.8408 102.881 78.8477C103.523 78.8408 103.824 78.2529 103.824 77.3438C103.824 76.4551 103.544 75.8467 102.881 75.8535C102.245 75.8672 101.931 76.4619 101.924 77.3438ZM107.051 82.7441C107.044 81.2812 107.81 80.2764 109.129 80.2832C110.482 80.2764 111.2 81.2812 111.207 82.7441C111.2 84.207 110.462 85.2051 109.129 85.2051C107.782 85.2051 107.044 84.2002 107.051 82.7441ZM108.172 82.7441C108.179 83.6396 108.493 84.2344 109.129 84.2344C109.771 84.2344 110.072 83.6396 110.072 82.7441C110.072 81.8418 109.792 81.2402 109.129 81.2402C108.5 81.2539 108.179 81.8486 108.172 82.7441Z",
    fill: "#CDD0DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.333 33C136.333 34.4728 137.527 35.6667 139 35.6667C140.473 35.6667 141.667 34.4728 141.667 33C141.667 31.5272 140.473 30.3333 139 30.3333C137.527 30.3333 136.333 31.5272 136.333 33ZM40.3333 33C40.3333 34.4728 41.5272 35.6667 43 35.6667C44.4728 35.6667 45.6667 34.4728 45.6667 33C45.6667 31.5272 44.4728 30.3333 43 30.3333C41.5272 30.3333 40.3333 31.5272 40.3333 33ZM139 32.5H43V33.5H139V32.5Z",
    fill: "#CDD0DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3333 81C81.3333 82.4728 82.5272 83.6667 84 83.6667C85.4728 83.6667 86.6667 82.4728 86.6667 81C86.6667 79.5272 85.4728 78.3333 84 78.3333C82.5272 78.3333 81.3333 79.5272 81.3333 81ZM7.33333 81C7.33333 82.4728 8.52724 83.6667 10 83.6667C11.4728 83.6667 12.6667 82.4728 12.6667 81C12.6667 79.5272 11.4728 78.3333 10 78.3333C8.52724 78.3333 7.33333 79.5272 7.33333 81ZM84 80.5L10 80.5L10 81.5L84 81.5L84 80.5Z",
    fill: "#CDD0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionMap3);
export default __webpack_public_path__ + "static/media/Section_map_3.3bf5bf613faabcd3310d8011d4e9bb39.svg";
export { ForwardRef as ReactComponent };